import React from 'react';

import { Orientation, Size, Theme } from '@lumapps/lumx/react';

export type HoveredCallback = (isHovered: boolean) => void;

export type SubscribeMenuHovered = (triggerElement: Element, cb: HoveredCallback) => void;

export interface MenuVariant {
    size?: Extract<Size, 's' | 'm'>;
    theme: Theme;
    orientation?: Orientation;
}

export type MenuContextOptions = {
    /** Menu is loading. */
    isLoading?: boolean;
    /** Menu orientation */
    orientation: Orientation;
    /** Close the topmost menu. */
    closeRoot?(): void;
    /** Is the topmost menu. */
    isRoot?: boolean;
    /** Menu Variant */
    menuVariant: MenuVariant;
    /** Context menu type */
    type: 'Menu' | 'Menubar';
};

export const MenuContext = React.createContext<MenuContextOptions | undefined>(undefined);
